export const GET_DEACTIVATION_REQUEST = "GET_DEACTIVATION_REQUEST";
